import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { StoreProvider } from "./Context/StoreProvider";
import { AuthProvider } from "./Auth";
import App from "./App";

import "swiper/css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "react-image-gallery/styles/css/image-gallery.css";

import "./Assets/Styles/ColorPalette.css";
import "./Assets/Styles/App.css";
import "./Assets/Styles/index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <StoreProvider>
          <App />
        </StoreProvider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
